module.exports = __webpack_public_path__ + "img/f52.37973d49.png";